import * as R from 'ramda';

export type NavigationDirection = 1 | -1;

type HorizontalDirections = 'left' | 'right';
type VerticalDirections = 'up' | 'down';
export type Orientation = 'horizontal' | 'vertical';
export type SlickerDirection = HorizontalDirections | VerticalDirections;

type TeceoSlickerLib = {
  getNextIndex: (
    selectedIndex: number,
    direction: NavigationDirection,
    slidersLength: number,
  ) => number;
  isNextIndex: (index: number, direction: NavigationDirection, slidersLength: number) => boolean;
  getIndexSlickerDirection: (
    index: number,
    selectedIndex: number,
    navigationDirection: NavigationDirection,
    slidersLength: number,
    orientation?: Orientation,
  ) => SlickerDirection;
  getMultipleVisible: (
    selectedIndex: number,
    qtItemsVisible: number,
    slidersLength: number,
  ) => number[];
};

const getNextIndex = (
  selectedIndex: number,
  direction: NavigationDirection,
  slidersLength: number,
) => R.mathMod(selectedIndex + direction, slidersLength);

const isNextIndex = (index: number, direction: NavigationDirection, slidersLength: number) => {
  const nextIndex = getNextIndex(index, direction, slidersLength);
  return nextIndex === index;
};

const getIndexSlickerDirection = (
  index: number,
  selectedIndex: number,
  navigationDirection: NavigationDirection,
  slidersLength: number,
  orientation?: Orientation,
) => {
  const foward = orientation === 'vertical' ? 'down' : 'left';
  const backward = orientation === 'vertical' ? 'up' : 'right';
  if (index === selectedIndex || isNextIndex(index, navigationDirection, slidersLength)) {
    return navigationDirection > 0 ? foward : backward;
  }
  return navigationDirection > 0 ? backward : foward;
};

const getMultipleVisible = (
  selectedIndex: number,
  qtItemsVisible: number,
  slidersLength: number,
) => {
  const visibleIndexes = [selectedIndex];

  let navFactor = 1;
  while (visibleIndexes.length < qtItemsVisible || visibleIndexes.length === slidersLength) {
    const prevIndex = selectedIndex - navFactor;
    if (prevIndex >= 0) {
      visibleIndexes.unshift(prevIndex);
    }

    const nextIndex = selectedIndex + navFactor;
    if (slidersLength > nextIndex && visibleIndexes.length < qtItemsVisible) {
      visibleIndexes.push(nextIndex);
    }

    navFactor += 1;
  }

  return visibleIndexes;
};

const teceoSlickerLib: TeceoSlickerLib = {
  getNextIndex,
  isNextIndex,
  getIndexSlickerDirection,
  getMultipleVisible,
};

export default teceoSlickerLib;
